import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() text: string = '';
  @Input() class: string = '';
  @Output() clicked = new EventEmitter<any>();

  onClick(){
    this.clicked.emit();
  }
}
